import { useJourneysData2 } from './useJourneysData2'

const useJourneyMapState = () => {
  const {
    view,
    mapRef,
    showJourneyAuthorization,
    setShowJourneyAuthorization,
    setShowTicket,
    showTicket,
    setFocussedJourney,
    focussedJourney,
    showEditJourney,
    setShowEditJourney,
    handleViewChange,
    showJourneyForm,
    setShowJourneyForm,
    showAirJourneyForm,
    setShowAirJourneyForm,
    submittedPopup,
    setSubmittedPopup,
    showMbForm,
    search,
    showRouteForm,
    setShowRouteForm,
    focusedAirJourney,
    setFocusedAirJourney,
    fromPin,
    setFromPin,
    toPin,
    setToPin,
    showLoading,
    setShowLoading,
    movementBoxes,
    setMovementBoxes,
    focusedMb,
    users,
    email,
    removeAirPins,
    startRoute,
    finishJourney,
    journeyDisplay,
    journeyMode,
    setshowMbForm,
    resetFilters,
    getHeights,
    showJourneysList,
    setShowJourneysList,
    setShowAirTravelList,
    setShowBackToJourneysMapButton,
    showMapKey,
    setShowMapKey,
    boxMeasures,
    setRoutePins,
    routePins,
  } = useJourneysData2()

  return {
    view,
    mapRef,
    showJourneyAuthorization,
    setShowJourneyAuthorization,
    setShowTicket,
    showTicket,
    setFocussedJourney,
    focussedJourney,
    showEditJourney,
    setShowEditJourney,
    handleViewChange,
    showJourneyForm,
    setShowJourneyForm,
    showAirJourneyForm,
    setShowAirJourneyForm,
    submittedPopup,
    setSubmittedPopup,
    showMbForm,
    search,
    showRouteForm,
    setShowRouteForm,
    focusedAirJourney,
    setFocusedAirJourney,
    fromPin,
    setFromPin,
    toPin,
    setToPin,
    showLoading,
    setShowLoading,
    movementBoxes,
    setMovementBoxes,
    focusedMb,
    users,
    email,
    removeAirPins,
    startRoute,
    finishJourney,
    journeyDisplay,
    journeyMode,
    setshowMbForm,
    resetFilters,
    getHeights,
    showJourneysList,
    setShowJourneysList,
    setShowAirTravelList,
    setShowBackToJourneysMapButton,
    showMapKey,
    setShowMapKey,
    boxMeasures,
    setRoutePins,
    routePins,
  }
}

export default useJourneyMapState
